// @flow

const init = {
    isEdit: false,
    isUserList: true,
    userInfo: {
        UserId: 0,
        UserName: "",
        Email: "",
        FirstName: "",
        LastName: "",
        Phone: "",
        Status: true,
        RoleId: 3,
        UserPrivelege: [],
        LastLogin: '',
        RoleName: ''
    },
    roleData: [],
    isDuplicate: false,
    viewDetail: false

}


const reducerUser = (state = init, action) => {
    switch (action.type) {
        case 'USER_ROLE_LIST':
            return {
                ...state,
                isEdit: false,
                type: action.type,
                roledata: action.payload,
            }

        case 'USER_DEFAULT_PRIVILEGE':
            return {
                ...state,
                isEdit: false,
                type: action.type,
                roledata: action.payload.roleList,
                userInfo: { ...state.userInfo, UserPrivelege: action.payload.privilege }
            }
        case 'USER_PRIVILEGE_BY_ROLE':
            return {
                ...state,
                isEdit: false,
                type: action.type,
                userInfo: { ...state.userInfo, UserPrivelege: action.payload }
            }
        case 'USER_PRIVILEGE_BY_USER':
            return {
                ...state,
                isEdit: false,
                type: action.type,
                userInfo: { ...state.userInfo, UserPrivelege: action.payload }
            }
        case 'USER_DETAIL_WITH_PRIVILEGE':
            return {
                ...state,
                isEdit: false,
                type: action.type,
                privilegedata: action.payload
            }
        case 'USER_VALIDATE_IN_AD':
            return {
                ...state,
                type: action.type

            }
        case 'USER_ADD':
            return {
                ...state,
                isEdit: false,
                userInfo: { ...state.userInfo, UserPrivelege: [] },
                isUserList: false,
                type: action.type,
                isDuplicate: false

            }
        case 'USER_CHANGE_PRIVILEGE':
            return {
                ...state,
                isEdit: false,
                userInfo: { ...state.userInfo },
                isUserList: false,
                type: action.type

            }
        case 'USER_ISDUPLICATE':
            return {
                ...state,
                isEdit: false,
                isUserList: false,
                type: action.type,
                isDuplicate: action.payload.isDuplicate,
                userInfo: { ...state.userInfo, UserId: action.payload.userId }
            }
        case 'USER_VIEW':
            return {
                ...state,
                isEdit: true,
                userInfo: { ...action.payload.UserDetail, UserPrivelege: action.payload.UserPrivilege },
                isUserList: false,
                type: action.type
            }
        case 'USER_EDIT_SUBMITED':
            return {
                ...state,
                isEdit: false,
                userInfo: { ...action.payload.UserDetail, UserPrivelege: action.payload.UserPrivilege },
                isUserList: true,
                type: action.type
            }
        case 'USER_LIST':
            return {
                ...state,
                isEdit: false,
                isUserList: true,
                viewDetail: false,
                type: action.type,
                roledata: action.payload
            }

        default:
            return state;
    }
};

export default reducerUser;
